import { render, staticRenderFns } from "./widgets_hot_values.vue?vue&type=template&id=19782db2&scoped=true&"
import script from "./widgets_hot_values.vue?vue&type=script&lang=js&"
export * from "./widgets_hot_values.vue?vue&type=script&lang=js&"
import style0 from "./widgets_hot_values.vue?vue&type=style&index=0&id=19782db2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19782db2",
  null
  
)

export default component.exports